import { Inject, Injectable } from '@angular/core';
import { BearerService } from './bearer.service';
import { APP_CONFIG, AppConfig } from '../../appconfig/appconfig';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestHeaderService {
  private readonly messages = {
    noToken: 'no token found',
    noAppKey: 'no app key found'
  }
  
  constructor(
    private bearerService: BearerService,
    @Inject(APP_CONFIG)
    private config: AppConfig,
  ) {}

  private getHeaderMetadata(token: string): {[key: string]: string;} {
    return {
      Authorization: `Bearer ${token}`,
      'Access-Mgmt-Apptoken': this.getAccessManagementAppKey(),
    };
  }

  /** get header promises */
  getHeaderPromise(): Promise<{[key: string]: string;}> {
    return new Promise((resolve, reject) => {
      this.bearerService.getTokenPromise().then((token) => {
        resolve(this.getHeaderMetadata(token.accessToken))
      }).catch(error => reject(error));
    });
  }

  /** get header observables */
  getHeaderObservable(): Observable<{[key: string]: string;}> {
    return this.bearerService.getTokenObservable().pipe(map(token => {
      return this.getHeaderMetadata(token || this.messages.noToken)
    }))
    
  }

  private getAccessManagementAppKey(): string {
    const key: string = `${this.config.digitalAccessPortal?.applicationId}-applicationToken`;
    return sessionStorage.getItem(key) || this.messages.noAppKey ;
  }
}
